module.exports = __webpack_public_path__ + "img/logo-light.74711b06.svg";